import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import { FaChevronCircleLeft } from "react-icons/fa";
import { useDefaultPath } from "../../hooks/useDefaultPath";

export function BackToHomeButton(): ReactElement {
  const defaultPath = useDefaultPath();
  return (
    <Link to={defaultPath}>
      <Button
        variant="btn_secondary"
        size="xs"
        fontSize="sm"
        leftIcon={<FaChevronCircleLeft />}
      >
        Home
      </Button>
    </Link>
  );
}
